import UserProfileMenu from '@/features/auth/user-profile-menu';

import { useCurrentUser } from '@/hooks/useApiKey';
import { useLogout } from '@/hooks/useLogout';

import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
} from '@/components/ui/sidebar';

import UserMenu from './user-menu';

export function NoTeamSidebar() {
    const logout = useLogout({ isSessionExpired: false });
    const [currentUser] = useCurrentUser();

    return (
        <Sidebar collapsible="icon" data-testid="NoTeamSidebar">
            <SidebarHeader>
                <UserMenu />
            </SidebarHeader>
            <SidebarContent />
            <SidebarFooter>
                <UserProfileMenu user={currentUser} onLogout={logout} />
            </SidebarFooter>
        </Sidebar>
    );
}
